import React, { Fragment, useContext } from "react";
import { makeStyles } from "tss-react/mui";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import { GlobalsContext } from "../../../context/globals";
import logo_blanco_color from "../../../images/logo_blanco_color.png";
import logo_negro from "../../../images/logo_negro.png";
import ConectionAlert from "../../conectionAlert";
import packageJson from "../../../../package.json";
import { APP_SHORT_NAME } from "../../../const/app";
import fondo_dark from "../../../images/fondo_dark.png";
import fondo_light from "../../../images/fondo_light.png";
import fondo_mid from "../../../images/fondo_mid.png";

const useStyles = makeStyles()((theme) => {
  const espaciado = theme.spacing(4); // 32px
  return {
    container: {
      minHeight: "100%",
      backgroundColor: "#00203a",
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundAttachment: "fixed",
    },
    leftContainer: {
      padding: espaciado,
      "& img": {
        width: "100%",
        maxWidth: 720,
      },
    },
    rightContainer: {
      position: "relative",
      padding: espaciado,
      "& > *": {
        width: "100%",
        maxWidth: 360,
      },
      "& h1": {
        textAlign: "center",
        fontSize: "1.35rem",
        lineHeight: 1.3,
        fontWeight: 600,
        margin: "0.75rem 0 0",
      },
    },
    inputContainer: {
      padding: espaciado,
    },
    themeToggleWrap: {
      position: "absolute",
      top: espaciado,
      right: espaciado,
      zIndex: 1,
      width: "auto",
      maxWidth: "none",
    },
    themeToggle: {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
      backdropFilter: "blur(8px)",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        transform: "scale(1.05)",
      },
      "&.Mui-focusVisible": {
        backgroundColor: "rgba(255, 255, 255, 0.24)",
      },
      transition: "background-color 0.2s ease, transform 0.2s ease",
    },
    themeToggleLight: {
      backgroundColor: "rgba(0, 0, 0, 0.06)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.12)",
      },
      "&.Mui-focusVisible": {
        backgroundColor: "rgba(0, 0, 0, 0.14)",
      },
    },
  };
});

function Layout(props) {
  const { classes } = useStyles();
  const theme = useTheme();
  const prefersDarkMode = theme.palette.mode === "dark";
  const { darkModeOn, setDarkModeOn } = useContext(GlobalsContext);

  const handleToggleTheme = () => setDarkModeOn(!darkModeOn);

  return (
    <Fragment>
      <CssBaseline />
      <Grid
        container
        className={classes.container}
        direction="row"
        justifyContent="center"
        wrap="nowrap"
      >
        <Grid
          container
          size={12}
          justifyContent="center"
          alignItems="center"
          wrap="nowrap"
          sx={{ display: { xs: "none", md: "flex" } }}
          style={{
             backgroundImage: "url(" + fondo_dark + ")",
            backgroundPosition: "left",
          }}
          className={classes.leftContainer}
        >
           <img src={logo_blanco_color} alt="logo" />
        </Grid>
        <Grid
          container
          size={12}
          className={classes.rightContainer}
          direction="column"
          justifyContent="center"
          alignItems="center"
          wrap="nowrap"
          style={{
             backgroundImage: "url(" + (prefersDarkMode ? fondo_mid : fondo_light) + ")",
            backgroundPosition: "right",
          }}
        >
          <Box className={classes.themeToggleWrap}>
            <Tooltip title={darkModeOn ? "Usar modo claro" : "Usar modo oscuro"} arrow placement="left">
              <IconButton
                onClick={handleToggleTheme}
                className={prefersDarkMode ? classes.themeToggle : `${classes.themeToggle} ${classes.themeToggleLight}`}
                size="medium"
                aria-label={darkModeOn ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
              >
                {prefersDarkMode ? (
                  <LightModeRoundedIcon sx={{ fontSize: 26 }} />
                ) : (
                  <DarkModeRoundedIcon sx={{ fontSize: 26 }} />
                )}
              </IconButton>
            </Tooltip>
          </Box>
          <img
            src={prefersDarkMode ? logo_blanco_color : logo_negro}
            alt="logo"
          />
          <h1>{APP_SHORT_NAME}</h1>
          <Fade in={true} timeout={1000}>
            <Paper className={classes.inputContainer}>{props.children}</Paper>
          </Fade>

          <Box pt={1}>
            <Typography variant="body2" color="textSecondary" align="center">
              {'Desarrollado por el Ministerio de Salud - Chaco ' + new Date().getFullYear()}
            </Typography>

            <Typography variant="body2" color="textSecondary" align="center">
              versión {packageJson.version}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <ConectionAlert />
    </Fragment>
  );
}

export default Layout;
